import { render } from "./RouteLivePanel.vue?vue&type=template&id=08f0826e&scoped=true"
import script from "./RouteLivePanel.vue?vue&type=script&lang=ts"
export * from "./RouteLivePanel.vue?vue&type=script&lang=ts"

import "./RouteLivePanel.vue?vue&type=style&index=0&id=08f0826e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08f0826e"

export default script